export const MEMBER_NAME_HTML_TAG = {
  RESPONSIVE: 'h1',
  NON_RESPONSIVE: 'h1',
  MOBILE: 'h1',
} as const;
